import { styled } from 'linaria/react';

export const Tag = styled.div`
	display: inline-block;
	margin: 4px;
	padding: 0 8px;
	font-size: 14px;
	line-height: 18px;
	border: 1px solid var(--gray200);
	border-radius: 4px;
	background: var(--gray50);
	color: var(--grau700);
	cursor: pointer;
`;
